/** @format */

import { combineReducers } from '@reduxjs/toolkit';
import { reducer as usersReducer } from 'src/slices/users';
import { reducer as ticketsReducer } from 'src/slices/tickets';
import { reducer as globalReducer } from 'src/slices/global';
import { reducer as knowledgeBaseReducer } from 'src/slices/knowledgeBase';

const rootReducer = combineReducers({
  users: usersReducer,
  global: globalReducer,
  tickets: ticketsReducer,
  knowledgeBase: knowledgeBaseReducer
});

export default rootReducer;
